import type { TextJobResponse } from "@surevai/contracts";

const API_BASE = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");

export async function textCheckerAvailable(): Promise<boolean> {
  const response = await fetch(`${API_BASE}/health`, { cache: "no-store" });
  if (!response.ok) return false;
  const health = await response.json() as { textReady?: boolean };
  return health.textReady === true;
}

async function readResponse<T>(response: Response): Promise<T> {
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const message = body && typeof body === "object" && "message" in body && typeof body.message === "string"
      ? body.message : "The text check could not be completed.";
    throw new Error(message);
  }
  return body as T;
}

export interface NewTextJob { jobId: string; accessToken: string; expiresAt: string }

export async function createTextJob(text: string, turnstileToken?: string): Promise<NewTextJob> {
  return readResponse<NewTextJob>(await fetch(`${API_BASE}/api/v1/text/jobs`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text, turnstileToken }),
  }));
}

export async function getTextJob(jobId: string, token: string): Promise<TextJobResponse> {
  return readResponse<TextJobResponse>(await fetch(`${API_BASE}/api/v1/text/jobs/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` }, cache: "no-store",
  }));
}

export async function deleteTextJob(jobId: string, token: string): Promise<void> {
  await readResponse(await fetch(`${API_BASE}/api/v1/text/jobs/${jobId}`, {
    method: "DELETE", headers: { Authorization: `Bearer ${token}` },
  }));
}
